import Error404 from './Error404';
import HomePage from './HomePage';
import CompanyPage from './CompanyPage';
import ProductPage from './ProductPage';
import TextPage from './TextPage';
import ChroniquePage from './ChroniquePage';
import ReferencePage from './ReferencePage';
import EmploiPage from './EmploiPage';
import NewOfferPage from './NewOfferPage';
import Login from './Login';
import GenericPage from './GenericPage';
import ContactPage from './ContactPage';
import ContactFormPage from './ContactFormPage';
export {
  HomePage,
  CompanyPage,
  ProductPage,
  TextPage,
  ChroniquePage,
  ReferencePage,
  Error404,
  EmploiPage,
  NewOfferPage,
  GenericPage,
  Login,
  ContactPage,
  ContactFormPage,
};



// WEBPACK FOOTER //
// ./src/pages/index.js